import { Grid, GridItem, RadioField, RadioInput } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import { useState } from 'react';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../utils/coverablesUtil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import type { CarOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';
import { currentPackageGroupAtom } from '../../../../recoil/atoms/currentPackageGroupAtom';

const CarPackageToggle = ({
    isLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const setCurrentPackageGroup = useSetRecoilState(currentPackageGroupAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourName = '', fixedId = '' } = currentProduct ?? {};
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as CarOnsaDTO;
    const [toggleValue, setToggleValue] = useState(
        coverable.packageGroupName === 'Liability' ? 'Kun ansvar' : 'Kasko og ansvar'
    );
    const getGroupName = (value: string): string =>
        value === 'Kasko og ansvar' ? 'Default' : 'Liability';

    const togglePackages = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setToggleValue(event.target.value);
        updateCoverableInformation({
            packageGroupName: getGroupName(event.target.value)
        });
        setCurrentPackageGroup(getGroupName(event.target.value));
    };

    return (
        <Grid className="u-spacing-inset-bottom-7">
            <GridItem colStart={5} span={4}>
                <RadioField
                    disabled={isLoading}
                    variant="button-toolbar"
                    value={toggleValue}
                    stacked={false}
                    onChange={togglePackages}
                >
                    <RadioInput
                        value={'Kasko og ansvar'}
                        label={getHippoText(
                            'DSS-COVERAGE-PACKAGE-PAGE-COMPREHENSIVE-AND-LIABILITY-RADIO-GROUP'
                        )}
                    />
                    <RadioInput
                        value={'Kun ansvar'}
                        label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-ONLY-LIABILITY-RADIO-GROUP')}
                    />
                </RadioField>
            </GridItem>
        </Grid>
    );
};

export default CarPackageToggle;
